<!-- PROGRESS BAR -->
<app-progress-bar></app-progress-bar>
<div *ngIf='(progressBarService._visible | async)' class='loading-shade-full'
     style='background:rgba(0, 0, 0, 0.3) !important;'>
  <mat-spinner *ngIf='(progressBarService._visible | async)' color='accent'></mat-spinner>
</div>
<!-- / PROGRESS BAR -->
<router-outlet></router-outlet>
